// eslint-disable-next-line monorepo/no-internal-import
import type {AuthMedium} from '@aboutyou/user/src/user-state/userStore/types';
import {sha256} from '../../../global-utils/helper-implementations/sha256';
import {TrackingCustomerData} from '../../../types';
import {TrackingClientStateHolder} from '../helpers/clientState';
import {executeTrackBasketAction} from './trackBasketAction';

export interface CustomerDataEventGA4 {
  event: 'customer_data';
  customer_id: number | null;
  cidhash: string | null;
  customer_type: 'guest' | 'existing' | 'new';
  login: boolean;
  login_method: 'none' | AuthMedium;
  nkta: number | null;
  bi_vp: boolean;
  eh: string | null;
  transactions: number | null;
}

export const CUSTOMER_DATA_GA4_EVENT = 'customer_data';

export const trackCustomerData =
  ({customer}: {customer: TrackingCustomerData}) =>
  (clientState: TrackingClientStateHolder) => {
    const {customerDataInitialized, queuedBasketActions} =
      clientState.getCurrent();
    clientState.update({
      customerDataInitialized: true,
    });

    const {customerId, cidhash} = getCustomerIdAndCustomerIdHash(customer);

    const eventGA4: CustomerDataEventGA4 = {
      event: CUSTOMER_DATA_GA4_EVENT,
      customer_id: customerId,
      cidhash,
      customer_type: customer.type,
      login: customer.type !== 'guest',
      login_method: customer.type !== 'guest' ? customer.loginType : 'none',
      nkta: customer.type !== 'guest' ? customer.pc180Score : null,
      bi_vp: customer.type === 'existing' ? customer.vip : false,
      eh: customer.type !== 'guest' ? customer.emh : null,
      transactions: customer.type !== 'guest' ? customer.transactions : null,
    };

    // Execute queued basket actions
    if (customerDataInitialized) {
      queuedBasketActions.map(executeTrackBasketAction(clientState));
      clientState.update({queuedBasketActions: []});
    }

    return {
      GA4: eventGA4,
    };
  };

const getCustomerIdAndCustomerIdHash = (customer: TrackingCustomerData) => {
  const noCustomerId = {
    customerId: null,
    cidhash: null,
  };

  if (customer.type === 'guest') {
    return noCustomerId;
  } else if (
    (customer.type === 'new' || customer.type === 'existing') &&
    customer.id !== undefined
  ) {
    const cidNumber = Number(customer.id);
    const cidString = customer.id.toString();
    const isCIDNumber = !isNaN(cidNumber);

    return isCIDNumber
      ? {
          customerId: cidNumber,
          cidhash: sha256(cidString) || null,
        }
      : noCustomerId;
  } else {
    // make ts happy
    return noCustomerId;
  }
};
